export default __webpack_public_path__ + "static/media/build-1.cc46d20a.png";